var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRighticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_57",
    "data-name": "Rectangle 57",
    width: 30,
    height: 30,
    transform: "translate(85.894 253.472)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(-85.894 -253.472)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check-circle-fill",
    transform: "translate(85.894 253.472)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_186",
    "data-name": "Group 186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_185",
    "data-name": "Group 185"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M30,15A15,15,0,1,1,15,0,15,15,0,0,1,30,15ZM22.556,9.319a1.406,1.406,0,0,0-2.025.041l-6.512,8.3L10.1,13.731a1.406,1.406,0,0,0-1.987,1.987l4.961,4.963a1.406,1.406,0,0,0,2.023-.038l7.485-9.356a1.406,1.406,0,0,0-.019-1.969Z",
    fill: "#bcbaba"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRighticon);
export default __webpack_public_path__ + "static/media/righticon.f08efd8997e71eb2b6435b1b5e1cce26.svg";
export { ForwardRef as ReactComponent };